var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"scroller",attrs:{"id":"home_wrapper"}},[_c('div',{staticClass:"position-relative",attrs:{"id":"home"}},[_c('HeroRoof'),_vm._v(" "),_c('Events'),_vm._v(" "),_c('FeaturesEvents'),_vm._v(" "),_c('AppFooter'),_vm._v(" "),_c('div')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }